import React from 'reactx';
import {Grid, Row} from 'react-bootstrap';

class Roller extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <Grid>
        <Row>
          <h2>Comming soon!</h2>
        </Row>
      </Grid>
    );
  }
}

export default Roller;



/** WEBPACK FOOTER **
 ** ./scripts/components/Roller.jsx
 **/